module.exports = __webpack_public_path__ + "img/nav_help.aeda14b6.jpg";